import {
  LoadHolidaysActionTypes,
  LoadHolidaysActions,
} from '../../../../shared/modules/common-specification/actions/load-holidays.actions';

export interface HolidaysState {
  holidays: Date[];
}

export const initialState: HolidaysState = {
  holidays: null,
};

export function reducer(state = initialState, action: LoadHolidaysActions): HolidaysState {
  switch (action.type) {
    case LoadHolidaysActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        holidays: action.payload,
      } as HolidaysState;
    }
    default: {
      return state;
    }
  }
}
